<template lang="html">
	<form :class="classBinding" @submit.prevent="isValid()">
		<div class="form-content" :class="form.class" v-for="form in forms">
			<label
				v-if="
					form.type !== 'checkbox' &&
					form.type != 'button' &&
					form.type != 'upload' &&
					form.type != 'textarea' &&
					form.type != 'datepicker' &&
					form.type != 'datepicker_from' &&
					form.type != 'datepicker_to' &&
					form.type != 'select_other' &&
					form.type != 'select'
				"
				class="form-label"
				v-html="form.label || form.model"
			></label>

			<label
				v-if="
					form.type !== 'checkbox' &&
					form.type != 'button' &&
					form.type != 'upload' &&
					form.sub_label
				"
				class="small-label"
				v-html="form.sub_label"
			></label>

			<InputText
				v-if="form.type === 'text' && !form.car_make && !form.car_model"
				:name="form.model"
				:prepend="form.prepend"
				:append="form.append"
				:type="form.form_type"
				:model="formData_[form.model]"
				v-model="formData_[form.model]"
				:action="form.name"
				:placeholder="form.placeholder"
				@input="validateItem(form)"
			/>

			<InputText
				v-if="form.type === 'text' && form.car_make"
				:name="form.model"
				:prepend="form.prepend"
				:append="form.append"
				:type="form.form_type"
				:model="formData_[form.model]"
				v-model="formData_[form.model]"
				:action="form.name"
				:placeholder="form.placeholder"
				@input="
					form.type === 'text' && form.car_make
						? filterItems(formData_[form.model])
						: validateItem(form)
				"
			/>

			<InputText
				v-if="form.type === 'text' && form.car_model"
				:name="form.model"
				:prepend="form.prepend"
				:append="form.append"
				:type="form.form_type"
				:model="formData_[form.model]"
				v-model="formData_[form.model]"
				:action="form.name"
				:placeholder="form.placeholder"
				@input="
					form.type === 'text' && form.car_model
						? showModels(formData_[form.model])
						: validateItem(form)
				"
			/>
			<ul
				id="autocomplete-results"
				v-show="isMakeOpen && form.car_make"
				class="autocomplete-results"
			>
				<li
					v-for="(result, i) in results"
					:key="i"
					class="autocomplete-result"
					@click="setResult(result, form.model)"
				>
					{{ result.brand }}
				</li>
			</ul>
			<ul
				id="autocomplete-results"
				v-show="isModelOpen && form.car_model"
				class="autocomplete-results"
			>
				<li
					v-for="(model, i) in carModels"
					:key="i"
					class="autocomplete-result"
					@click="setModel(model, form.model)"
				>
					{{ model }}
				</li>
			</ul>

			<Select
				v-if="form.type === 'select_other'"
				v-model="formData_[form.model]"
				:label="form.label"
				:multiple="form.multiple || true"
				:clearable="form.clearable || true"
				:filterable="form.filterable || false"
				:max-tag-count="form.max_tag_count || 3"
				@input="openTextAreaSelect(formData_[form.model], form)"
			>
				<Option
					v-for="(item, index) in form.options"
					:value="item.val"
					:key="index"
					>{{ item.label }}</Option
				>
			</Select>

			<Select
				v-if="
					form.type === 'select' &&
					(!form.parent_model ||
						form.parent_model === 'n/a' ||
						form.parent_model === '')
				"
				v-model="formData_[form.model]"
				:label="form.label"
				:multiple="form.multiple || false"
				:clearable="form.clearable || true"
				:filterable="form.filterable || false"
				:max-tag-count="form.max_tag_count || 3"
				@input="onSelectChange(form)"
			>
				<Option
					v-for="(item, index) in form.options"
					:value="item.val"
					:key="index"
					>{{ item.label }}</Option
				>
			</Select>

			<Select
				v-if="
					(form.type === 'select' &&
						checkLowerCase(formData_[form.parent_model], form) &&
						(form.parent_model === searchFieldYes(form) ||
							form.parent_model === searchFieldMulti(form))) ||
					(form.type === 'select' &&
						checkLowerCaseNo(formData_[form.parent_model]) &&
						form.parent_model === searchFieldNo(form))
				"
				v-model="formData_[form.model]"
				:label="form.label"
				:multiple="form.multiple || false"
				:clearable="form.clearable || true"
				:filterable="form.filterable || false"
				:max-tag-count="form.max_tag_count || 3"
				@input="validateItem(form)"
			>
				<Option
					v-for="(item, index) in form.options"
					:value="item.val"
					:key="index"
					>{{ item.label }}</Option
				>
			</Select>

			<Select
				v-if="form.type === 'select_yes_no'"
				v-model="formData_[form.model]"
				:multiple="form.multiple || false"
				:clearable="form.clearable || true"
				:filterable="form.filterable || false"
				:max-tag-count="form.max_tag_count || 3"
				@input="openYesTextArea(formData_[form.model], form)"
			>
				<Option
					v-for="(item, index) in form.options"
					:value="item.val"
					:key="index"
					>{{ item.label }}</Option
				>
			</Select>

			<Select
				v-if="form.type === 'select_yes'"
				v-model="formData_[form.model]"
				:multiple="form.multiple || false"
				:clearable="form.clearable || true"
				:filterable="form.filterable || false"
				:max-tag-count="form.max_tag_count || 3"
				@input="openYesTextArea(formData_[form.model], form)"
			>
				<Option
					v-for="(item, index) in form.options"
					:value="item.val"
					:key="index"
					>{{ item.label }}</Option
				>
			</Select>

			<Select
				v-if="form.type === 'select_no'"
				v-model="formData_[form.model]"
				:multiple="form.multiple || false"
				:clearable="form.clearable || true"
				:filterable="form.filterable || false"
				:max-tag-count="form.max_tag_count || 3"
				@input="openNoTextArea(formData_[form.model], form)"
			>
				<Option
					v-for="(item, index) in form.options"
					:value="item.val"
					:key="index"
					>{{ item.label }}</Option
				>
			</Select>

			<TextArea
				v-if="
					(form.type === 'textarea' &&
						checkLowerCase(formData_[form.parent_model], form) &&
						(form.parent_model === searchFieldYes(form) ||
							form.parent_model === searchFieldMulti(form))) ||
					(form.type === 'textarea' &&
						checkLowerCaseNo(formData_[form.parent_model]) &&
						form.parent_model === searchFieldNo(form))
				"
				:name="form.model"
				:label="form.label"
				v-model="formData_[form.model]"
				:action="form.name"
				:rows="form.rows"
				:placeholder="form.placeholder"
				@input="validateItem(form)"
			/>

			<TextArea
				v-if="
					form.type === 'textarea' &&
					(!form.parent_model ||
						form.parent_model === 'n/a' ||
						form.parent_model === '')
				"
				:name="form.model"
				:label="form.label"
				v-model="formData_[form.model]"
				:action="form.name"
				:rows="form.rows"
				:placeholder="form.placeholder"
				@input="validateItem(form)"
			/>

			<Mobile
				v-if="form.type === 'mobile'"
				v-model="formData_[form.model]"
				@input="validateItem(form)"
				:placeholder="form.placeholder"
			/>

			<button
				v-if="form.type === 'button'"
				class="btn form-btn"
				:class="form.btnClass"
				@click="btnClick(form.model)"
			>
				{{ form.label }}
			</button>

			<Checkbox
				v-if="form.type === 'checkbox'"
				:name="form.model"
				v-model="formData_[form.model]"
				:action="form.name"
				:label="form.label"
				@change="validateItem(form)"
			/>

			<DatePicker
				v-if="
					(form.type === 'datepicker' &&
						checkLowerCase(formData_[form.parent_model], form) &&
						(form.parent_model === searchFieldYes(form) ||
							form.parent_model === searchFieldMulti(form))) ||
					(form.type === 'datepicker' &&
						checkLowerCaseNo(formData_[form.parent_model]) &&
						form.parent_model === searchFieldNo(form))
				"
				:type="form.form_type || 'date'"
				:value="formData_[form.model]"
				:format="form.format || 'dd-MM-yyyy'"
				:placement="form.placement || 'bottom-end'"
				:placeholder="form.placeholder"
				:start-date="form.start_date || new Date()"
				:label="form.label"
				@on-change="handleChange($event, form)"
			>
			</DatePicker>

			<DatePicker
				v-if="
					form.type === 'datepicker' &&
					(!form.parent_model ||
						form.parent_model === 'n/a' ||
						form.parent_model === '')
				"
				:type="form.form_type || 'date'"
				:value="formData_[form.model]"
				:format="form.format || 'dd-MM-yyyy'"
				:placement="form.placement || 'bottom-end'"
				:placeholder="form.placeholder"
				:start-date="form.start_date || new Date()"
				:label="form.label"
				@on-change="handleChange($event, form)"
			>
			</DatePicker>

			<DatePicker
				v-if="form.type === 'datepicker_from'"
				:type="form.form_type || 'date'"
				:value="formData_[form.model]"
				:format="form.format || 'dd-MM-yyyy'"
				:placement="form.placement || 'bottom-end'"
				:placeholder="form.placeholder"
				:options="options3"
				:start-date="form.start_date || new Date()"
				:label="form.label"
				@on-change="handleChangeFrom($event, form)"
			>
			</DatePicker>

			<DatePicker
				v-if="form.type === 'datepicker_to' && selected_date !== ''"
				:type="form.form_type || 'date'"
				:value="formData_[form.model]"
				:format="form.format || 'dd-MM-yyyy'"
				:placement="form.placement || 'bottom-end'"
				:placeholder="form.placeholder"
				:options="dateOptions(selected_date)"
				:start-date="new Date(selected_date)"
				:label="form.label"
				@on-change="handleChangeTo($event, form)"
			>
			</DatePicker>

			<TimePicker
				v-if="form.type === 'timepicker'"
				:type="form.form_type || 'time'"
				:value="formData_[form.model]"
				:format="form.format || 'HH:mm'"
				:placement="form.placement || 'bottom-end'"
				:placeholder="form.placeholder"
				:steps="form.steps || [1, 5]"
				@on-change="handleChange($event, form)"
			>
			</TimePicker>

			<Radio
				v-if="form.type === 'radio'"
				:classes="form.classes"
				:name="form.model"
				v-model="formData_[form.model]"
				:action="form.name"
				:placeholder="form.placeholder"
				:options="form.options"
				@input="validateItem(form)"
			/>

			<Upload
				v-if="
					(form.type === 'upload' &&
						checkLowerCase(formData_[form.parent_model], form) &&
						(form.parent_model === searchFieldYes(form) ||
							form.parent_model === searchFieldMulti(form))) ||
					(form.type === 'upload' &&
						checkLowerCaseNo(formData_[form.parent_model]) &&
						form.parent_model === searchFieldNo(form))
				"
				:label="form.label"
				:name="form.model"
				:accept="form.accept"
				:multiple="form.multiple"
				v-model="formData_[form.model]"
				@file-selected="forwardEvent('file-selected', $event)"
			/>

			<Upload
				v-if="
					form.type === 'upload' &&
					(!form.parent_model ||
						form.parent_model === 'n/a' ||
						form.parent_model === '')
				"
				:label="form.label"
				:name="form.model"
				:accept="form.accept"
				:multiple="form.multiple"
				v-model="formData_[form.model]"
				@file-selected="forwardEvent('file-selected', $event)"
			/>

			<ColorPicker
				v-if="form.type === 'color'"
				v-model="formData_[form.model]"
				:hue="form.hue || true"
				:alpha="form.alpha || false"
				:recommend="form.recommend || false"
				:colors="form.colors"
				@on-change="validateItem(form)"
			/>

			<Rate
				v-if="form.type === 'rate'"
				v-model="formData_[form.model]"
				:allow-half="form.allow_half || false"
				:icon="form.icon"
				:character="form.character"
				@input="validateItem(form)"
			/>

			<Slider
				v-if="form.type === 'slider'"
				v-model="formData_[form.model]"
				:step="form.step"
				:min="form.min || 0"
				:max="form.max || 100"
				:show-stops="form.show_stops"
				:range="form.range"
				:marks="form.marks"
				@on-change="validateItem(form)"
			></Slider>

			<Location
				v-if="form.type === 'location'"
				:name="form.model"
				:model="formData_[form.model]"
				:placeholder="form.placeholder"
				v-model="formData_[form.model]"
				@on-change="validateItem(form)"
			></Location>

			<FormTable
				v-if="form.type === 'form-table'"
				:table="form.table"
				:forms="form.forms"
				v-model="formData_[form.model]"
			/>

			<!-- Validation Error -->
			<div class="form-err">{{ form.err }}</div>
		</div>
	</form>
</template>

<script>
import { Select, Option, OptionGroup } from './select/';
import { TimePicker } from './date-picker/index';

import customize from '../../../components/main/rsc/stores/customize-product.store';

export default {
	created() {
		utils.registerModule('customize', customize, this.$store);

		Event.$on('remote:receivedData', (payload) => {
			if (payload.formName === this.name) {
				this.remoteData[payload.name] = payload.data;
			}
		});
	},
	components: {
		Checkbox: () => import('./checkbox'),
		Radio: () => import('./radio'),
		Label: () => import('./label'),
		TextArea: () => import('./textarea'),
		InputText: () => import('./text'),
		ColorPicker: () => import('./color-picker/index'),
		DatePicker: () => import('./date-picker/index'),
		Slider: () => import('./slider/index'),
		Rate: () => import('./rate/index'),
		Upload: () => import('./upload'),
		Location: () => import('./location'),
		FormTable: () => import('./form-table'),
		Mobile: () => import('./mobile'),
		Select,
		Option,
		OptionGroup,
		TimePicker,
	},
	props: {
		forms: {
			type: Array,
			default: function () {
				return [];
			},
		},
		classBinding: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		formData: {
			type: Object,
			default: function () {
				return {};
			},
		},
	},
	watch: {
		forms(oldVal, newVal) {
			this.formData_ = utils.generateFormData(newVal);
		},
	},
	computed: {
		...mapGetters(['specificSelect']),
	},
	data() {
		return {
			formData_: this.formData,
			hasErrors: false,
			remoteData: {},
			items: [],
			results: [],
			models: [],
			carModels: [],
			isMakeOpen: false,
			isModelOpen: false,
			isTextAreaOpen: false,
			loading: false,
			yes_fields: [],
			no_fields: [],
			multi_fields: [],
			cars: utils.getCars(),
			selected_date: '',
			options3: {
				disabledDate(date) {
					return date && date.valueOf() < Date.now() - 86400000;
				},
			},
		};
	},
	methods: {
		dateOptions(dt) {
			const options4 = {
				disabledDate(date) {
					let end_date = new Date(
						new Date(dt).setFullYear(
							new Date(dt).getFullYear() + 1,
						),
					);
					end_date.setDate(end_date.getDate() - 1);
					return (
						(date && date.valueOf() < new Date(dt) - 86400000) ||
						date.valueOf() > end_date
					);
				},
			};
			return options4;
		},
		checkLowerCase(data, form) {
			if (data) {
				switch (typeof data) {
					case 'string':
						if (data.toLowerCase() === 'yes') {
							return true;
						} else {
							return false;
						}
						break;

					case 'object':
						const ifOther = data.find(
							(item) => item.toLowerCase() === 'other',
						);

						if (ifOther) {
							return true;
						}
						break;

					default:
						break;
				}
			}
		},
		checkLowerCaseNo(data) {
			if (data) {
				switch (typeof data) {
					case 'string':
						if (data.toLowerCase() === 'no') {
							return true;
						}
						break;

					// case 'object':
					//   const ifOther = data.find((item) => item.toLowerCase() === 'other');
					//   if (ifOther) {
					//     return true;
					//   }
					//   break;

					default:
						break;
				}
			}
		},
		searchFieldYes(form) {
			const spec = this.yes_fields.find((field) => {
				return field === form.parent_model;
			});
			return spec;
		},
		searchFieldNo(form) {
			const spec = this.no_fields.find((field) => {
				return field === form.parent_model;
			});
			return spec;
		},
		searchFieldMulti(form) {
			const spec = this.multi_fields.find((field) => {
				return field === form.parent_model;
			});

			return spec;
		},
		openYesTextArea(data, form) {
			console.log(this.formData_);
			if (data.toLowerCase() === 'yes') {
				const fieldExist = this.yes_fields.find((field) => {
					return field === form.model;
				});
				if (!fieldExist) {
					this.yes_fields.push(form.model);
				}
			}
		},
		openNoTextArea(data, form) {
			if (data.toLowerCase() === 'no') {
				const fieldExist = this.no_fields.find((field) => {
					return field === form.model;
				});
				if (!fieldExist) {
					this.no_fields.push(form.model);
				}
			}
		},
		openTextAreaSelect(data, form) {
			const spec = data.find((item) => {
				return item.toLowerCase() === 'other';
			});

			if (spec) {
				this.multi_fields.push(form.model);
			}
		},
		handleSelectChange(data, form) {
			if (data) {
				this.formData_[form.model] = data;
				console.log('Changed data', data);
			}
		},
		onSelectChange(form) {
			Event.$emit('select-field-changed', {
				form,
				data: this.formData_[form.model],
			});
			this.validateItem(form);
		},
		initializeRemoteData() {
			for (let i = 0; i < this.forms.length; i++) {
				const form = this.forms[i];

				if (form.type === 'remote') {
					this.remoteData = { [form.remoteName]: [] };
				}
			}
		},
		resetForms() {
			this.formData_ = utils.generateFormData(this.forms);
		},
		forwardEvent(name, e) {
			this.$emit(name, e);
		},
		btnClick(name) {
			this.$emit('button-click', { ref: this, name });
		},
		handleChangeFrom(date, form) {
			this.formData_[form.model] = date;
			this.selected_date = date;
			this.validateItem(form);
		},
		handleChangeTo(date, form) {
			this.formData_[form.model] = date;
			this.validateItem(form);
		},
		handleChange(date, form) {
			this.formData_[form.model] = date;
			this.validateItem(form);
		},
		async validateItem(form) {
			if (form.validation && !form.parent_model) {
				let result = await validate(
						this.formData_[form.model],
						form.validation,
						{ name: form.model },
					),
					err = undefined;

				if (!result.valid) {
					this.hasErrors = true;
					err = result.errors[0];
				}

				form.err = err;
				this.$forceUpdate();
			}
		},
		filterItems(model) {
			this.loading = true;
			this.isMakeOpen = true;
			try {
				return new Promise(async (resolve, reject) => {
					let res = await api.fetchEndpoint(
						{
							resource: 'search',
							action: 'text_field_search',
							data: {
								field_sub_type: 'crsp_Make',
							},
							meta_data: {},
						},
						'/client',
					);

					//  this.results = res.result.filter((item) => {
					//    let str = item["'name'"];
					//    str = str.slice(1, str.length - 1);

					//    return str.toLowerCase().indexOf(model.toLowerCase()) > -1;
					//  });

					this.results = this.cars.filter((car) => {
						return (
							car.brand
								.toLowerCase()
								.indexOf(model.toLowerCase()) > -1
						);
					});

					this.loading = false;

					resolve();
				});
			} catch (err) {
				reject(err);
			}
		},
		showModels(model) {
			this.isModelOpen = true;

			this.carModels = this.models.filter((m) => {
				return m.toLowerCase().indexOf(model.toLowerCase()) > -1;
			});
		},
		setResult(data, model) {
			this.formData_[model] = data.brand;
			this.isMakeOpen = false;
			this.models = data.models;
		},
		setModel(data, model) {
			this.formData_[model] = data;
			this.isModelOpen = false;
		},
		async isValid() {
			this.hasErrors = false;

			for (let i = 0; i < this.forms.length; i++) {
				const form = this.forms[i];
				await this.validateItem(form);
			}

			if (!this.hasErrors) {
				this.$emit('submit', this.formData_);
				return true;
			} else {
				$notify(
					'warning',
					'Validation Errors',
					'Fix form inputs with errors before proceeding',
					30,
				);
				return false;
			}
		},
	},
	mounted() {
		this.initializeRemoteData();
	},
};
</script>
<style lang="less" scoped>
.autocomplete {
	position: relative;
	width: 130px;
}

.autocomplete-results {
	padding: 0;
	margin: 0;
	border: 1px solid #eeeeee;
	height: 120px;
	overflow: auto;
	width: 100%;
}

.autocomplete-result {
	list-style: none;
	text-align: left;
	padding: 4px 2px;
	cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
	background-color: #4aae9b;
	color: white;
}
</style>
